<template>
  <v-col class="px-5">
    <h2>{{ $translate('INTERESTS') }}</h2>

    <v-slide-y-transition>
    <ErrorCard
      v-if="error"
      :errorMessage="errorMessage"
      :functionName="errorToRecallFunction"
      @getTagGroupsForUser="getTagGroupsForUser"
      @saveTagGroupsForUser="saveTagGroupsForUser"
    />
    </v-slide-y-transition>

    <v-row class="pl-5">
      <template v-for="(column, index) in this.columns">
        <v-col :key="index">
          <template v-for="(tag, index) in column">
            <v-row :key="index">
              <v-switch
                @change="saveTagGroupsForUser(tag)"
                v-model="tag.Selected"
                :label="tag.TagGroup"
              ></v-switch>
            </v-row>
          </template>
        </v-col>
      </template>
    </v-row>
  </v-col>
</template>

<script>
import utility from '@/shared/utility';
import ErrorCard from '../generalComponents/ErrorHandling/ErrorCard';
import doRequest from '@/api/dssRequest';

export default {
  created() {},
  data() {
    return {
      // ErrorCard variables
      error: false,
      errorMessage: this.$translate('FAILED_GET_INTERESTS'),
      errorToRecallFunction: 'getTagGroupsForUser',

      tags: {},
      array: [],
      cols: 2,
    };
  },
  mounted() {
    this.getTagGroupsForUser();
  },
  components: {
    ErrorCard,
  },
  name: 'UserSettingsInterests',
  props: [],
  watch: {},
  computed: {
    columns() {
      const columns = [];
      this.array = utility.objectToArray(this.tags);
      const mid = Math.ceil(this.array.length / this.cols);
      for (let col = 0; col < this.cols; col++) {
        columns.push(this.array.slice(col * mid, col * mid + mid));
      }
      return columns;
    },
  },
  methods: {
    getTagGroupsForUser() {
      this.error = false;

      const payload = {
        PartnerId: -1,
        FunctionId: 'TagsFunctionLibrary::getTagGroupsForUser',
      };
      doRequest(
        (response) => {
          this.tags = response.data.TagGroups;
          console.log(this.tags);
        },
        (error) => {
          this.error = true;
          this.errorMessage = this.$translate('FAILED_GET_INTERESTS');
          this.errorToRecallFunction = 'getTagGroupsForUser';
        },
        'communicateWithDBLibrary',
        this.$store.getters['Account/partnerGroupDetails'].AccountId,
        payload,
      );
    },
    saveTagGroupsForUser(tag) {
      // set the value of the switch button into the tag in the array
      this.tags[tag.TagId].Selected = tag.Selected;
      this.error = false;
      const payload = {
        FunctionId: 'TagsFunctionLibrary::saveTagGroupsForUser',
        PartnerId: -1,
        TagGroups: this.tags,
      };
      doRequest(
        (response) => {},
        (error) => {
          this.error = true;
          this.errorMessage = this.$translate('FAILED_SAVING_INTERESTS');
          this.errorToRecallFunction = 'saveTagGroupsForUser';
        },
        'communicateWithDBLibrary',
        this.$store.getters['Account/partnerGroupDetails'].AccountId,
        payload,
      );
    },
  },
};
</script>

<style scoped lang="scss">
a {
  text-decoration: inherit;
  color: inherit;
  cursor: auto;
}
</style>
